var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import trackingImage from './tracking-image';
import beacon from './beacon';
import * as LOG_LEVEL from './constants';

var API_PATH = '/v1/';

export { LOG_LEVEL };
export default function frontendEvents(configuration) {
  var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  if ((typeof configuration === 'undefined' ? 'undefined' : _typeof(configuration)) !== 'object' || !configuration) {
    throw new TypeError('expected configuration object');
  }

  var _configuration$baseUr = configuration.baseUrl,
      baseUrl = _configuration$baseUr === undefined ? 'https://eu.klarnaevt.com' : _configuration$baseUr,
      client = configuration.client,
      clientVersion = configuration.clientVersion,
      sessionId = configuration.sessionId,
      _configuration$instan = configuration.instanceId,
      instanceId = _configuration$instan === undefined ? Math.floor(Math.random() * 9000) + 1000 : _configuration$instan;

  var logLevel = configuration.logLevel || LOG_LEVEL.ALL;

  if (typeof client !== 'string') {
    throw new TypeError('expected `client` in the configuration object');
  }
  if (typeof clientVersion !== 'string') {
    throw new TypeError('expected `clientVersion` in the configuration object');
  }
  if (typeof sessionId !== 'string') {
    throw new TypeError('expected `sessionId` in the configuration object');
  }
  if (typeof logLevel !== 'number' || logLevel < LOG_LEVEL.ALL || logLevel > LOG_LEVEL.OFF) {
    throw new TypeError('invalid `logLevel` (' + logLevel + ')');
  }

  function buildQueryParams(options) {
    return Object.keys(options)
    // We cannot guarantee order of keys here, to be able to test it, we need to sort them.
    .sort().map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(options[k]);
    }).join('&');
  }

  function buildUrl(name, options) {
    return '' + baseUrl + API_PATH + client + '/' + clientVersion + '/' + name + '?' + buildQueryParams(options);
  }

  function event(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var postData = arguments[2];
    var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : LOG_LEVEL.ALL;

    if (logLevel > level) {
      // Skip logging
      return;
    }

    if (!name) {
      throw new TypeError('expected `name` as first parameter');
    }

    options = _extends({}, options, {
      iid: instanceId,
      sid: sessionId,
      timestamp: options.timestamp || new Date().getTime()
    });

    var url = buildUrl(name, options);

    try {
      beacon.create(win, url, postData);
    } catch (e) {
      // if beacon is not available we need to append possible post data to url as well
      if (postData) {
        url += '&' + buildQueryParams(postData);
      }
      trackingImage.create(win, url);
    }
  }

  function trace(name, options, postData) {
    event(name, options, postData, LOG_LEVEL.TRACE);
  }

  function debug(name, options, postData) {
    event(name, options, postData, LOG_LEVEL.DEBUG);
  }

  function info(name, options, postData) {
    event(name, options, postData, LOG_LEVEL.INFO);
  }

  function warn(name, options, postData) {
    event(name, options, postData, LOG_LEVEL.WARN);
  }

  function error(name, options, postData) {
    event(name, options, postData, LOG_LEVEL.ERROR);
  }

  function fatal(name, options, postData) {
    event(name, options, postData, LOG_LEVEL.FATAL);
  }

  function setLogLevel() {
    var newLogLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LOG_LEVEL.ALL;

    if (typeof newLogLevel !== 'number' || newLogLevel < LOG_LEVEL.ALL || newLogLevel > LOG_LEVEL.OFF) {
      throw new TypeError('invalid `logLevel` (' + newLogLevel + ')');
    }

    logLevel = newLogLevel;
  }

  function getConfig() {
    return {
      baseUrl: baseUrl,
      client: client,
      clientVersion: clientVersion,
      sessionId: sessionId,
      instanceId: instanceId,
      logLevel: logLevel
    };
  }

  return {
    event: event,
    trace: trace,
    debug: debug,
    info: info,
    warn: warn,
    error: error,
    fatal: fatal,
    setLogLevel: setLogLevel,
    getConfig: getConfig
  };
}